import api from 'Application/api/api';

const uploadDocsFromPortal = (signal, file) =>
	api.post('/epc-offers/partner/upload-docs', file, {
		signal,
		timeout: 100000,
		headers: {
			'Content-Type': 'multipart/form-data',
			Accept: '*/*',
		},
	});

export default uploadDocsFromPortal;
